import React, { Component } from "react";
import teamImg from "../../imgs/team.png";
import teamImgBg from "../../imgs/team-bg.png";
import Greg from "../../imgs/greg.png";
import Jared from "../../imgs/jared.png";
import Twitter from "../../imgs/twitter-white.png";
import Instagram from "../../imgs/instagram-white.png";
import Texture from "../../imgs/textured-bg.png";
import panda from "../../imgs/panda-1.png";
import panda2 from "../../imgs/panda-2.png";
export default class About extends Component {
  render() {
    return (
      <div>
        <div
          style={{ backgroundImage: `url(${Texture})` }}
          className="shop pt-5"
        >
          <div className="about-container team-container">
            <div className="team-card d-flex flex-column align-items-start">
              <img className="user-img" src={Jared} />
              <h6 className="text-lg losnello mb-0">Jared</h6>
              <p className="text-sm mb-3 ">Founder | Entreperneur</p>
              <div className="d-flex flex-row align-items-center">
                <a
                  href="https://twitter.com/jaredlichtman"
                  className="social-icon me-3"
                >
                  <img src={Twitter} />
                </a>
                <a
                  href="https://instagram.com/jaredlichtman
"
                  className="social-icon"
                >
                  <img src={Instagram} />
                </a>
              </div>
            </div>

            <div className="team-card d-flex flex-column align-items-start">
              <img className="user-img" src={Greg} />
              <h6 className="text-lg losnello mb-0">Greg AKA GSTAKIS</h6>
              <p className="text-sm mb-3 ">Founder | Successful Artist</p>
              <div className="d-flex flex-row align-items-center">
                <a
                  href="https://twitter.com/gstakis_dglabs"
                  className="social-icon me-3"
                >
                  <img src={Twitter} />
                </a>
                <a href="https://instagram.com/gstakis" className="social-icon">
                  <img src={Instagram} />
                </a>
              </div>
            </div>

            <div className="team-card d-flex flex-column align-items-start">
              <img className="user-img" src={panda} />
              <h6 className="text-lg losnello mb-0">Rex</h6>
              <p className="text-sm mb-3 ">Digital Artist</p>
              <div className="d-flex flex-row align-items-center">
                <a
                  href="https://instagram.com/theartofrex"
                  className="social-icon"
                >
                  <img src={Instagram} />
                </a>
              </div>
            </div>

            <div className="team-card d-flex flex-column align-items-start">
              <img className="user-img" src={panda2} />
              <h6 className="text-lg losnello mb-0">Maria</h6>
              <p className="text-sm mb-3 ">Metaverse Architect</p>
              <div className="d-flex flex-row align-items-center">
                <a
                  href="https://instagram.com/orange.silk"
                  className="social-icon"
                >
                  <img src={Instagram} />
                </a>
              </div>
            </div>
          </div>

          <div className="mt-5 text-container pb-5">
            <h6 className="text-lg text-center losnello mb-5">
              Learn More Below
            </h6>
            <p className="text-md text-left mb-5">
              DG Labs is a NFT art studio founded by visual artist G-STAKIS and
              successful businessman Jared. Our goal is to bridge the gap
              between the physical and digital worlds.
            </p>
            <p className="text-md text-left mb-5">
              At Dope Gallery Labs, we focus on integrating the latest,
              cutting-edge technologies with original art concepts that enhance
              the way we experience and interact with art! With over 13 years of
              experience as a professional artist, GSTAKIS is implementing
              augmented reality and VR technologies to his concepts creating a
              unique hybrid art style, unlike anything we’ve ever seen before!
              DG Labs is a manifesto of two passionate entrepreneurs with over
              25 years of friendship who are determined to be leaders in the NFT
              space and change the way people interact with and experience art
              forever.
            </p>
            <p className="text-md text-left mb-5">
              Click below to read more about us and what we're building.
            </p>

            <a
              href="https://drive.google.com/file/d/1ybutuMIc6tJFvfKG0VAsPymQ2EPhwmaF/view?usp=sharing"
              className="big-btn  text-md icon--menu-toggle regular"
            >
              Dopepaper
            </a>
          </div>
        </div>
      </div>
    );
  }
}
